/**
 * Actions designed for non-persistent editing of charts by token, i.e. report view page
 */

export enum ChartViewActionType {
  DrillDown = '[ViewChart] DrillDown',
  DynamicDrillDown = '[ViewChart] DynamicDrillDown',
  ChangeHierarchy = '[ViewChart] ChangeHierarchy',

  UpdateEncoding = '[ViewChart] UpdateEncoding',
}
